import Vue from 'vue';
import { Line, mixins } from 'vue-chartjs';
import Chart from 'chart.js';
const { reactiveProp } = mixins;


(<any>Chart).Legend.prototype.afterFit = function() {
  this.height = this.height + 10;
};

export default Vue.extend({
  extends: Line,
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  mounted() {
    // @ts-ignore
    this.renderChart(this.chartData, this.options);
  }
});
